/** Checks if we are in production environment. */
const isProduction = () => process.env.NODE_ENV === 'production';

export { isProduction };
